import Checkbox from '../../../../common/components/Checkbox.js'
import {
  activeSupplierOptionTokensSelector,
  activeSupplierOptionsSelector,
  useSuppliersSelector,
} from '../../../../data/suppliers.js'
import {useSelector} from '../../../../store.js'
import FilterPanel from '../../../OrderListPage/Modals/OrderListFilterModal/FilterPanel.js'
import {
  modalFormSelector,
  SUPPLIER_FILTER_PANEL,
  updateModalForm,
} from './productListFilterModalFunctions.js'

function NoSupplier() {
  const form = useSelector(modalFormSelector)

  return (
    <div className="margin-bottom-30">
      <div className="inline-block">
        <Checkbox
          labelClassName="margin-bottom-0"
          mode="fancy"
          id="product__no_supplier"
          checked={form.no_supplier}
          onChange={() => updateModalForm({no_supplier: !form.no_supplier})}
          label="No Supplier Assigned"
          disabled={form.supplierID.length > 0}
        />
      </div>
    </div>
  )
}

export default function SupplierFilterPanel() {
  const form = useSelector(modalFormSelector)
  const supplierOptions = useSelector(activeSupplierOptionsSelector)
  const supplierOptionTokens = useSelector(activeSupplierOptionTokensSelector)
  const useSuppliers = useSelector(useSuppliersSelector)

  if (!(useSuppliers && supplierOptions.length > 0)) {
    return null
  }

  return (
    <FilterPanel
      id={SUPPLIER_FILTER_PANEL}
      label="Suppliers"
      searchPlaceholder="Search for a supplier filter..."
      options={supplierOptions}
      optionTokens={supplierOptionTokens}
      selected={form.supplierID}
      onSelect={(option) => {
        const supplierID = form.supplierID.filter((id) => id !== option.value)

        if (supplierID.length === form.supplierID.length) {
          supplierID.push(option.value)
        }

        updateModalForm({supplierID})
      }}
      ExtraOptions={NoSupplier}
      allDisabled={form.no_supplier}
    />
  )
}
